import { render, staticRenderFns } from "./LeftNewsDataList.vue?vue&type=template&id=3918d64c&scoped=true&"
import script from "./LeftNewsDataList.vue?vue&type=script&lang=js&"
export * from "./LeftNewsDataList.vue?vue&type=script&lang=js&"
import style0 from "./LeftNewsDataList.vue?vue&type=style&index=0&id=3918d64c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3918d64c",
  null
  
)

export default component.exports